module.exports = __webpack_public_path__ + "static/mockup_phone@3x-9e9e25319c5b617f1f401cda7d6090f9.png";